interface IUseLogosProps {
  logos: string[]
}
export const useLogos = ({ logos }: IUseLogosProps) => {
  const firstLogo = logos?.[0]
  const secondLogo = logos?.[1]
  const hasTwoLogos = logos?.length === 2 && firstLogo !== secondLogo
  return { hasTwoLogos, firstLogo, secondLogo }
}
